/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для списка акций в корзине
   */
  app.CartDiscountsView = app.View.extend({
    el: '.discounts',
    template: '#cart-discounts-template',
    itemTemplate: '#cart-discount-template',

    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.itemTemplate = app.helpers.TemplateHelper.getTemplate(this.itemTemplate);
      this.listenTo(this.model, 'reset', this.render);
    },

    render: function () {
      if (this.model.length) {
        var allDiscounts = [],
        discountsListHtml = '';
        _.each(this.model.models, (function (discount) {
          var data = {
            model: discount.toJSON(),
            currentFraction: app.helpers.NumberHelper.numberWithoutZeroFraction(discount.getCurrent()),
            endFraction: app.helpers.NumberHelper.numberWithoutZeroFraction(discount.getEnd()),
            restFraction: app.helpers.NumberHelper.numberWithoutZeroFraction(discount.getRest()),
            percent: discount.getPercent(),
            isLargeFamily: discount.get('type') === 'large_family',
            isQtyDiscount: discount.get('accumulateQty') !== undefined,
            isNewBadgeColors: app.features && app.features.is_new_badge_colors,
          };
          allDiscounts.push(data);
        }));
        allDiscounts.sort(function (a, b) {
            return b.percent - a.percent;
        });
        _.each(allDiscounts, (function (discount) {
          discountsListHtml += this.itemTemplate(discount);
        }).bind(this));
        this.$el.html(this.template({
          discountsList: discountsListHtml,
        }));
        this.rewritePageLinks();
        return;
      }
      this.$el.html('');
    }
  });
})();

}.call(window));